var map = {
	"./App": "./App/UserBox/components/App.jsx",
	"./App.jsx": "./App/UserBox/components/App.jsx",
	"./CasinoGame": "./App/UserBox/components/CasinoGame.jsx",
	"./CasinoGame.jsx": "./App/UserBox/components/CasinoGame.jsx",
	"./CloseButton": "./App/UserBox/components/CloseButton.jsx",
	"./CloseButton.jsx": "./App/UserBox/components/CloseButton.jsx",
	"./DashboardPVRToolbar": "./App/UserBox/components/DashboardPVRToolbar.jsx",
	"./DashboardPVRToolbar.jsx": "./App/UserBox/components/DashboardPVRToolbar.jsx",
	"./DepositToolsList/DepositByEcoupon": "./App/UserBox/components/DepositToolsList/DepositByEcoupon.jsx",
	"./DepositToolsList/DepositByEcoupon.jsx": "./App/UserBox/components/DepositToolsList/DepositByEcoupon.jsx",
	"./Env": "./App/UserBox/components/Env.jsx",
	"./Env.jsx": "./App/UserBox/components/Env.jsx",
	"./Init": "./App/UserBox/components/Init.jsx",
	"./Init.jsx": "./App/UserBox/components/Init.jsx",
	"./KeepAlive": "./App/UserBox/components/KeepAlive.jsx",
	"./KeepAlive.jsx": "./App/UserBox/components/KeepAlive.jsx",
	"./KomodoToolbar": "./App/UserBox/components/KomodoToolbar.jsx",
	"./KomodoToolbar.jsx": "./App/UserBox/components/KomodoToolbar.jsx",
	"./Mission": "./App/UserBox/components/Mission.jsx",
	"./Mission.jsx": "./App/UserBox/components/Mission.jsx",
	"./MissionsList": "./App/UserBox/components/MissionsList.jsx",
	"./MissionsList.jsx": "./App/UserBox/components/MissionsList.jsx",
	"./News": "./App/UserBox/components/News.jsx",
	"./News.jsx": "./App/UserBox/components/News.jsx",
	"./NewsConfirmButton": "./App/UserBox/components/NewsConfirmButton.jsx",
	"./NewsConfirmButton.jsx": "./App/UserBox/components/NewsConfirmButton.jsx",
	"./NewsList": "./App/UserBox/components/NewsList.jsx",
	"./NewsList.jsx": "./App/UserBox/components/NewsList.jsx",
	"./Page/DepositTools": "./App/UserBox/components/Page/DepositTools.jsx",
	"./Page/DepositTools.jsx": "./App/UserBox/components/Page/DepositTools.jsx",
	"./Page/MemobetList": "./App/UserBox/components/Page/MemobetList.jsx",
	"./Page/MemobetList.jsx": "./App/UserBox/components/Page/MemobetList.jsx",
	"./Page/TicketsList": "./App/UserBox/components/Page/TicketsList.jsx",
	"./Page/TicketsList.jsx": "./App/UserBox/components/Page/TicketsList.jsx",
	"./Page/UPage": "./App/UserBox/components/Page/UPage.jsx",
	"./Page/UPage.jsx": "./App/UserBox/components/Page/UPage.jsx",
	"./Page/WithdrawalTools": "./App/UserBox/components/Page/WithdrawalTools.jsx",
	"./Page/WithdrawalTools.jsx": "./App/UserBox/components/Page/WithdrawalTools.jsx",
	"./Storage": "./App/UserBox/components/Storage.jsx",
	"./Storage.jsx": "./App/UserBox/components/Storage.jsx",
	"./Styles": "./App/UserBox/components/Styles.jsx",
	"./Styles.jsx": "./App/UserBox/components/Styles.jsx",
	"./TabCoupon": "./App/UserBox/components/TabCoupon.jsx",
	"./TabCoupon.jsx": "./App/UserBox/components/TabCoupon.jsx",
	"./TabNews": "./App/UserBox/components/TabNews.jsx",
	"./TabNews.jsx": "./App/UserBox/components/TabNews.jsx",
	"./TabPanel": "./App/UserBox/components/TabPanel.jsx",
	"./TabPanel.jsx": "./App/UserBox/components/TabPanel.jsx",
	"./TabProfile": "./App/UserBox/components/TabProfile.jsx",
	"./TabProfile.jsx": "./App/UserBox/components/TabProfile.jsx",
	"./Table/Deposit": "./App/UserBox/components/Table/Deposit.jsx",
	"./Table/Deposit.jsx": "./App/UserBox/components/Table/Deposit.jsx",
	"./Table/DepositToolsList": "./App/UserBox/components/Table/DepositToolsList.jsx",
	"./Table/DepositToolsList.jsx": "./App/UserBox/components/Table/DepositToolsList.jsx",
	"./Table/MemobetList": "./App/UserBox/components/Table/MemobetList.jsx",
	"./Table/MemobetList.jsx": "./App/UserBox/components/Table/MemobetList.jsx",
	"./Table/PromotionCasinoGameList": "./App/UserBox/components/Table/PromotionCasinoGameList.jsx",
	"./Table/PromotionCasinoGameList.jsx": "./App/UserBox/components/Table/PromotionCasinoGameList.jsx",
	"./Table/TicketList/Data": "./App/UserBox/components/Table/TicketList/Data.jsx",
	"./Table/TicketList/Data.jsx": "./App/UserBox/components/Table/TicketList/Data.jsx",
	"./Table/TicketList/FilterTicket": "./App/UserBox/components/Table/TicketList/FilterTicket.jsx",
	"./Table/TicketList/FilterTicket.jsx": "./App/UserBox/components/Table/TicketList/FilterTicket.jsx",
	"./Table/TicketList/Ticket": "./App/UserBox/components/Table/TicketList/Ticket.jsx",
	"./Table/TicketList/Ticket.jsx": "./App/UserBox/components/Table/TicketList/Ticket.jsx",
	"./Table/TicketList/TicketList": "./App/UserBox/components/Table/TicketList/TicketList.jsx",
	"./Table/TicketList/TicketList.jsx": "./App/UserBox/components/Table/TicketList/TicketList.jsx",
	"./Table/TicketsList": "./App/UserBox/components/Table/TicketsList.jsx",
	"./Table/TicketsList.jsx": "./App/UserBox/components/Table/TicketsList.jsx",
	"./Table/Withdrawal": "./App/UserBox/components/Table/Withdrawal.jsx",
	"./Table/Withdrawal.jsx": "./App/UserBox/components/Table/Withdrawal.jsx",
	"./Table/WithdrawalToolsList": "./App/UserBox/components/Table/WithdrawalToolsList.jsx",
	"./Table/WithdrawalToolsList.jsx": "./App/UserBox/components/Table/WithdrawalToolsList.jsx",
	"./Tabs": "./App/UserBox/components/Tabs.jsx",
	"./Tabs.jsx": "./App/UserBox/components/Tabs.jsx",
	"./Toolbar": "./App/UserBox/components/Toolbar.jsx",
	"./Toolbar.jsx": "./App/UserBox/components/Toolbar.jsx",
	"./ToolbarCompact": "./App/UserBox/components/ToolbarCompact.jsx",
	"./ToolbarCompact.jsx": "./App/UserBox/components/ToolbarCompact.jsx",
	"./ToolbarIcon": "./App/UserBox/components/ToolbarIcon.jsx",
	"./ToolbarIcon.jsx": "./App/UserBox/components/ToolbarIcon.jsx",
	"./ToolbarInline": "./App/UserBox/components/ToolbarInline.jsx",
	"./ToolbarInline.jsx": "./App/UserBox/components/ToolbarInline.jsx",
	"./UPage": "./App/UserBox/components/UPage.jsx",
	"./UPage.jsx": "./App/UserBox/components/UPage.jsx",
	"./UPopup": "./App/UserBox/components/UPopup.jsx",
	"./UPopup.jsx": "./App/UserBox/components/UPopup.jsx",
	"./UserSettings": "./App/UserBox/components/UserSettings.jsx",
	"./UserSettings.jsx": "./App/UserBox/components/UserSettings.jsx",
	"./Widget/Account": "./App/UserBox/components/Widget/Account.jsx",
	"./Widget/Account.jsx": "./App/UserBox/components/Widget/Account.jsx",
	"./Widget/Assistenza": "./App/UserBox/components/Widget/Assistenza.jsx",
	"./Widget/Assistenza.jsx": "./App/UserBox/components/Widget/Assistenza.jsx",
	"./Widget/Cashout": "./App/UserBox/components/Widget/Cashout.jsx",
	"./Widget/Cashout.jsx": "./App/UserBox/components/Widget/Cashout.jsx",
	"./Widget/CasinoPromotion": "./App/UserBox/components/Widget/CasinoPromotion.jsx",
	"./Widget/CasinoPromotion.jsx": "./App/UserBox/components/Widget/CasinoPromotion.jsx",
	"./Widget/Coupon": "./App/UserBox/components/Widget/Coupon.jsx",
	"./Widget/Coupon.jsx": "./App/UserBox/components/Widget/Coupon.jsx",
	"./Widget/Freebets": "./App/UserBox/components/Widget/Freebets.jsx",
	"./Widget/Freebets.jsx": "./App/UserBox/components/Widget/Freebets.jsx",
	"./Widget/Funbonus": "./App/UserBox/components/Widget/Funbonus.jsx",
	"./Widget/Funbonus.jsx": "./App/UserBox/components/Widget/Funbonus.jsx",
	"./Widget/LastLogins": "./App/UserBox/components/Widget/LastLogins.jsx",
	"./Widget/LastLogins.jsx": "./App/UserBox/components/Widget/LastLogins.jsx",
	"./Widget/LoginCard": "./App/UserBox/components/Widget/LoginCard.jsx",
	"./Widget/LoginCard.jsx": "./App/UserBox/components/Widget/LoginCard.jsx",
	"./Widget/LoyaltySystemBadge": "./App/UserBox/components/Widget/LoyaltySystemBadge.jsx",
	"./Widget/LoyaltySystemBadge.jsx": "./App/UserBox/components/Widget/LoyaltySystemBadge.jsx",
	"./Widget/MasterAgentBadge": "./App/UserBox/components/Widget/MasterAgentBadge.jsx",
	"./Widget/MasterAgentBadge.jsx": "./App/UserBox/components/Widget/MasterAgentBadge.jsx",
	"./Widget/MemobetLoader": "./App/UserBox/components/Widget/MemobetLoader.jsx",
	"./Widget/MemobetLoader.jsx": "./App/UserBox/components/Widget/MemobetLoader.jsx",
	"./Widget/SubAccounts": "./App/UserBox/components/Widget/SubAccounts.jsx",
	"./Widget/SubAccounts.jsx": "./App/UserBox/components/Widget/SubAccounts.jsx",
	"./Widget/TicketsList": "./App/UserBox/components/Widget/TicketsList.jsx",
	"./Widget/TicketsList.jsx": "./App/UserBox/components/Widget/TicketsList.jsx",
	"./Widget/UpdateUser": "./App/UserBox/components/Widget/UpdateUser.jsx",
	"./Widget/UpdateUser.jsx": "./App/UserBox/components/Widget/UpdateUser.jsx",
	"./Widget/UserInfo": "./App/UserBox/components/Widget/UserInfo.jsx",
	"./Widget/UserInfo.jsx": "./App/UserBox/components/Widget/UserInfo.jsx",
	"./Widget/VipSystem": "./App/UserBox/components/Widget/VipSystem.jsx",
	"./Widget/VipSystem.jsx": "./App/UserBox/components/Widget/VipSystem.jsx",
	"./Widget/WidgetBadge": "./App/UserBox/components/Widget/WidgetBadge.jsx",
	"./Widget/WidgetBadge.jsx": "./App/UserBox/components/Widget/WidgetBadge.jsx",
	"./Widget/WidgetGroup": "./App/UserBox/components/Widget/WidgetGroup.jsx",
	"./Widget/WidgetGroup.jsx": "./App/UserBox/components/Widget/WidgetGroup.jsx",
	"./Widget/WidgetMission": "./App/UserBox/components/Widget/WidgetMission.jsx",
	"./Widget/WidgetMission.jsx": "./App/UserBox/components/Widget/WidgetMission.jsx",
	"./Widget/WidgetTool": "./App/UserBox/components/Widget/WidgetTool.jsx",
	"./Widget/WidgetTool.jsx": "./App/UserBox/components/Widget/WidgetTool.jsx",
	"./less/keepalive.module": "./App/UserBox/components/less/keepalive.module.css",
	"./less/keepalive.module.css": "./App/UserBox/components/less/keepalive.module.css",
	"./less/keepalive.module.less": "./App/UserBox/components/less/keepalive.module.less",
	"./less/upage.less": "./App/UserBox/components/less/upage.less",
	"./less/userbox.less": "./App/UserBox/components/less/userbox.less"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./App/UserBox/components sync recursive ^\\.\\/.*$";